import { useEffect, useRef } from "react";
import type { VoiceGeographyGroup } from "@/utils/voiceCatalog";

function CountryCheckbox({ group, selected, onChange }: { group: VoiceGeographyGroup; selected: string[]; onChange: (keys: string[]) => void }) {
  const input = useRef<HTMLInputElement>(null);
  const keys = group.accents.map(accent => accent.key);
  const checked = keys.every(key => selected.includes(key));
  const partial = !checked && keys.some(key => selected.includes(key));
  useEffect(() => { if (input.current) input.current.indeterminate = partial; }, [partial]);
  return <label className="flex min-h-8 cursor-pointer items-start gap-2 rounded px-2 py-1.5 text-sm font-medium hover:bg-muted">
    <input ref={input} type="checkbox" checked={checked} aria-checked={partial ? "mixed" : checked}
      className="mt-0.5 accent-primary" onChange={() => onChange(checked ? selected.filter(key => !keys.includes(key)) : [...new Set([...selected, ...keys])])} />
    <span title={group.country}>{group.label}</span>
  </label>;
}

export default function VoiceGeographyFilter({ groups, selected, onChange }: { groups: VoiceGeographyGroup[]; selected: string[]; onChange: (keys: string[]) => void }) {
  return <fieldset className="min-w-0">
    <legend className="mb-2 text-sm font-medium">Country or region and accent</legend>
    <div className="max-h-72 overflow-y-auto overscroll-contain rounded-md border border-input bg-background p-1">
      {groups.map(group => <div key={group.country} role="group" aria-label={`${group.label} accents`}>
        <CountryCheckbox group={group} selected={selected} onChange={onChange} />
        {group.accents.length > 1 && <div className="ml-4 border-l border-border pl-1">
          {group.accents.map(accent => <label key={accent.key} className="flex min-h-8 cursor-pointer items-start gap-2 rounded px-2 py-1.5 text-sm hover:bg-muted">
            <input type="checkbox" checked={selected.includes(accent.key)} aria-label={`${group.label} – ${accent.label}`}
              className="mt-0.5 accent-primary" onChange={event => onChange(event.target.checked ? [...selected, accent.key] : selected.filter(key => key !== accent.key))} />
            <span>{accent.label}</span>
          </label>)}
        </div>}
      </div>)}
    </div>
  </fieldset>;
}
